<mat-accordion>
  <mat-expansion-panel [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>{{group.name}}</mat-panel-title>
    </mat-expansion-panel-header>
    <ul class="List-firstLevel">
      <li *ngFor="let teaser of group.documentTeasers">
        <div class="Header" [class.HasIndicator]="dateService.isLessThanOrEqualToDifferenceFromNow(teaser.publicationDate, newIndicatorDays)">
          <h3 *ngIf="teaser.title">
            <a [routerLink]="'../' + teaser.uniqueNumber">{{teaser.title}}</a>
            <span *ngIf="dateService.isLessThanOrEqualToDifferenceFromNow(teaser.publicationDate, newIndicatorDays)">
              &nbsp;({{dateService.getDifferenceInDaysFromNow(teaser.publicationDate)}} day<span *ngIf="dateService.getDifferenceInDaysFromNow(teaser.publicationDate) > 1">s</span> ago)
            </span>
          </h3>
          <!-- <legend *ngIf="teaser.publicationDate || teaser.creator">
            <time *ngIf="teaser.publicationDate">{{teaser.publicationDate | date :'mediumDate'}}</time>
            <span *ngIf="teaser.creator">{{teaser.creator}}</span>
          </legend> -->
          <p *ngIf="teaser.teaserSummary">{{teaser.teaserSummary}}</p>
        </div>
        <!-- <ul *ngIf="teaser.collectionHighlights.highlights" class="List List--small List-secondLevel">
          <li *ngFor="let highlight of teaser.collectionHighlights.highlights;">
            {{highlight.value}}
          </li>
        </ul> -->
      </li>
    </ul>
  </mat-expansion-panel>
</mat-accordion>
